var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',{staticClass:"container mt-4 mb-4 pl-1 pr-1"},[_c('LicitacaoItem',{attrs:{"id":_vm.$route.params.id}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }